import React from 'react';

import {formatDate} from 'utils/datetime';

import {SCHEDULE_ITEM_TYPES} from 'ducks/tenancy';

import Table from 'components/Table';
import Money from 'components/Money';
import Ellipsis from 'components/Ellipsis';

const DraftInvoiceRow = ({draftInvoice, handleRowClick, scheduleType}) => {
  const {draftInvoiceDetails} = draftInvoice;

  return (
    <Table.Row
      className="scheduleRow"
      onClick={() =>
        handleRowClick(
          SCHEDULE_ITEM_TYPES.DRAFT_INVOICE,
          draftInvoice.id,
          scheduleType
        )
      }>
      <Table.Cell>{formatDate(draftInvoice.date)}</Table.Cell>
      <Table.Cell>{formatDate(draftInvoiceDetails.dueDate)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="details">
        <Ellipsis>{draftInvoiceDetails.description}</Ellipsis>
      </Table.Cell>
      <Table.Cell>DRAFT</Table.Cell>
      <Table.Cell />
      <Table.Cell className="amount">
        <Money amount={draftInvoice.amount} balance />
      </Table.Cell>
      <Table.Cell />
      <Table.Cell className="balance">
        <Money amount={draftInvoice.balance} balance />
      </Table.Cell>
    </Table.Row>
  );
};

export default DraftInvoiceRow;
